// extracted by mini-css-extract-plugin
module.exports = {"flex":"AddRemoveButton_flex_3qael","add":"AddRemoveButton_add_3BO97","remove":"AddRemoveButton_remove_1RGZU","small":"AddRemoveButton_small_3cvXV"};